export default __webpack_public_path__ + "static/important-m-a8229bce1def81abc64d238214d4c43b.webp";